import {
  FETCH_YADS_STATUS_REQUEST,
  FETCH_YADS_STATUS_SUCCESS,
  FETCH_YADS_STATUS_FAILURE
} from '../../../Constants/actionTypes';

const initialState = {
  loading: false,
  statusData: [],  // array of status per tenant
  error: '',
};

const yadsStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_YADS_STATUS_REQUEST:
      return { ...state, loading: true };
    case FETCH_YADS_STATUS_SUCCESS:
      return { loading: false, statusData: action.payload, error: '' };
    case FETCH_YADS_STATUS_FAILURE:
      return { loading: false, statusData: [], error: action.payload };
    default:
      return state;
  }
};

export default yadsStatusReducer;
